export default __webpack_public_path__ + "static/media/short-text-ic.58be5330.svg";